import { type EmployeeTipStats } from '../../../shared/api/employee.service';
import { type CountryCode } from '../../../shared/config';
import {
  formatAmountValue,
  formatCurrency,
  resolveCurrencyPrefix,
} from '../../../shared/model';

function parseDashboardAmount(value?: string): number | null {
  const numericValue = Number.parseFloat(value ?? '');

  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return null;
  }

  return Math.round(numericValue);
}

export function formatDashboardCurrency(
  amount: string | undefined,
  countryCode: CountryCode,
): string {
  return formatCurrency(parseDashboardAmount(amount) ?? 0, countryCode);
}

export function resolveDashboardPositiveAmountParts(
  amount: string | undefined,
  countryCode: CountryCode,
): {
  prefix: string;
  value: string;
} {
  const normalizedAmount = parseDashboardAmount(amount) ?? 0;
  const amountLabel = formatAmountValue(normalizedAmount, countryCode);

  return {
    prefix: resolveCurrencyPrefix(countryCode),
    value: normalizedAmount > 0 ? `+${amountLabel}` : amountLabel,
  };
}

export function resolveDashboardWithdrawalProgressPercent(
  tipStats: EmployeeTipStats | null,
): number {
  const depositSumMonth = parseDashboardAmount(tipStats?.depositSumMonth);
  const withdrawalSumMonth = parseDashboardAmount(tipStats?.withdrawalSumMonth);

  if (
    depositSumMonth === null ||
    depositSumMonth <= 0 ||
    withdrawalSumMonth === null ||
    withdrawalSumMonth <= 0
  ) {
    return 0;
  }

  return Math.min(
    100,
    Math.max(0, Math.round((withdrawalSumMonth / depositSumMonth) * 100)),
  );
}
